import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
} from "react";
import { toast } from "react-toastify";
import ShowimageList from "./modalshowimagelistnps";
import ButtonDash from "../common/buttonDashboard";
import BranchContext from "../context/branch";
import {
  pclist,
  getImageType,
  getImagelist,
  getSite,
  getLocation,
  getCheckingPerson,
} from "../../services/pc";
import Renderwaitting from "./renderresignlist";
import ScrollToTop from "../common/ScrollToTop";
import DatePicker from "react-datepicker";
import PrivilegeContext from "../context/privilege";
import Input from "../common/inputfunction";
import Select from "../common/selectcustom1";
import { imagestus } from "./data";
import moment from "moment";
import { Link } from "react-router-dom";

const Waitpaylist = (props) => {
  const { currentBranch } = useContext(BranchContext);
  const { menuItems } = useContext(PrivilegeContext);
  const [refresh, setrefresh] = useState(new Date());
const code="nps";

  const [waiting, setwaiting] = useState([]);
  const [message, setmessage] = useState("");
  const [messageerror, setmessageerror] = useState("");

  const [Id, setId] = useState("");
  const [saveSuccess, setsaveSuccess] = useState(false);
  const [search, setsearch] = useState("");

  const [formData, setFormData] = useState({ siteid: 0 });
  const [messageError, setmessageError] = useState({
    imagetypeid: "",
  });

  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const [pageSize, setPageSize] = useState(30);
  const [data, setData] = useState([]);
  const statuslist = imagestus;
  const [sitelist, setSitelist] = useState([]);
  const [arealist, setarealist] = useState([]);
  const [checkinglist, setcheckinglist] = useState([]);

  const [total, setTotal] = useState(0);
  const [showonscroll, setshowonscroll] = useState(false);

  const [list, setlist] = useState([]);
  const [formload, setformload] = useState(false);

  const [isOpenList, setisOpenList] = useState(false);
  const [imagetypelist, setimagetypelist] = useState([]);

  useEffect(() => {
    if (!currentBranch) return;
    if (Id === "") return;

    const loadRegister = async () => {
      const { data: result } = await getImageType(code);

      if (result.status === "success") {
        setimagetypelist(result.data.list);
      }
    };

    loadRegister();
  }, [currentBranch, Id,code]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadRegister = async () => {
      const { data: result } = await getSite(code);

      if (result.status === "success") {
        setSitelist(result.data.list);
      }
    };

    loadRegister();
  }, [currentBranch,code]);

  useEffect(() => {
    if (!currentBranch) return;
    if (formData.siteid === undefined) return;

    const loadRegister = async () => {
      const { data: result } = await getLocation(formData.siteid,code);

      if (result.status === "success") {
        setarealist(result.data.list);
      }
    };

    loadRegister();
  }, [currentBranch, formData.siteid,code]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadRegister = async () => {
      const { data: result } = await getCheckingPerson(code);

      if (result.status === "success") {
        setcheckinglist(result.data.list);
      }
    };

    loadRegister();
  }, [currentBranch,code]);

  useEffect(() => {
    if (!currentBranch) return;
    if (Id === "") return;

    const loadRegister = async () => {
      const { data: result } = await getImagelist(Id,code);

      if (result.status === "success") {
        setlist(result.data.list);
      }
    };

    loadRegister();
  }, [currentBranch, Id, refresh,code]);

  useEffect(() => {
    if (!currentBranch) return;
    // if (!menuItems) return;
    // if (menuItems.length === 0) return;

    setwaiting([]);
  }, [
    currentBranch,
    formData.siteid,
    formData.areaid,
    formData.statusid,
    formData.checkby,code
  ]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!menuItems) return;
    if (menuItems.length === 0) return;

    setLoading(true);
    setError(false);

    const loadRegister = async () => {
      const { data: result } = await pclist(
        "2022",
        "",
        "",
        formData.siteid,
        formData.areaid,
        "",
        pageSize,
        pageNumber,
        formData.statusid,
        formData.checkby,code
      );

      if (result.status === "success") {
        setTotal(result.data.total);

        setwaiting((prevData) => {
          return [...new Set([...prevData, ...result.data.list])];
        });
        setHasMore(result.data.list.length > pageSize - 1);
        setLoading(false);
      }
    };

    loadRegister();
  }, [
    currentBranch,
    pageNumber,
    pageSize,
    menuItems,
    formData.siteid,
    formData.areaid,
    formData.statusid,
    formData.checkby,code
  ]);

  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (node && node.offsetTop > 0) {
        setshowonscroll(true);
      }
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  const clearmessage = () => {
    setmessage("");
    setmessageerror("");
  };
  const handleSelectChange = (inputKey, data) => {
    if (!data) return;
    setFormData({
      ...formData,
      [inputKey]: JSON.parse(data),
    });
    setPageNumber(1);
    if (JSON.parse(data) !== 0) {
      setmessageError({ ...messageError, [inputKey]: "" });
    }
  };

  const handleClick = (id) => {
    setId(id);
    setisOpenList(true);
  };
  const onConfirm = () => {
    setrefresh(new Date());
  };
  const handelImageClose = () => {
    setisOpenList(false);
  };

  return (
    <>
      <ShowimageList
        isOpen={isOpenList}
        header={"รูปภาพ"}
        onCancel={handelImageClose}
        list={list}
        id={Id}
        typelist={imagetypelist}
        onConfirm={onConfirm}
      />

      <div className="container-fluid">
        <div className="container-fluid">
          <h3 className="text-primary">รายการเช็ค PC</h3>
        </div>
        <div className="row">
          <div className="col-auto col-lg-2">
            <Select
              label="Site"
              data={sitelist}
              value={formData.siteid}
              name={"siteid"}
              onChange={handleSelectChange}
            />
          </div>

          <div className="col-auto col-lg-2">
            <Select
              label="Location"
              data={arealist}
              value={formData.areaid}
              name={"areaid"}
              onChange={handleSelectChange}
            />
          </div>

          <div className="col-auto col-lg-2">
            <Select
              label="สถานะ"
              data={statuslist}
              value={formData.statusid}
              name={"statusid"}
              onChange={handleSelectChange}
            />
          </div>

          <div className="col-auto col-lg-2">
            <Select
              label="ผู้ตรวจสอบ"
              data={checkinglist}
              value={formData.checkby}
              name={"checkby"}
              onChange={handleSelectChange}
            />
          </div>

          <div className="col-auto mt-4">
          <Link className={`text-primary`} target="_blank" to={{ pathname: `/dashboardnps`  }} ><i className="external-link" size='lg' />
          <button
              className="btn btn-primary btn-sm mt-2"
              // onClick={() => handleOnclick('dashboardpc')}
            >
              Dashboard
            </button>         
                        
                           </Link>

          
          </div>
        </div>

        <p className="text-success mt-2">
          แสดงข้อมูล {waiting ? waiting.length : 0} {" จากทั้งหมด "} {total}{" "}
          {"รายการ"}
        </p>

        {<ScrollToTop />}
        <Renderwaitting
          list={waiting}
          loading={loading}
          error={error}
          lastBookElementRef={lastBookElementRef}
          handleOnClick={handleClick}
        />
      </div>
    </>
  );
};

export default Waitpaylist;
